import { render } from "./Events.vue?vue&type=template&id=619244dc&scoped=true"
import script from "./Events.vue?vue&type=script&lang=js"
export * from "./Events.vue?vue&type=script&lang=js"

import "./Events.vue?vue&type=style&index=0&id=619244dc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619244dc"]])

export default __exports__